/**
 * slack_send_dm — canonical manifest (zero imports, shared with tool-runtime).
 *
 * Sends a direct message to a Slack user.
 * Always call contacts_log_interaction after a successful send.
 */

export const MANIFEST = {
  name: 'slack_send_dm',
  description: `Send a direct message to a Slack user.

**INTEGRATION REQUIRED:** User must connect a Slack workspace in Settings → Integrations first.

**IMPORTANT:** After a successful send, always call contacts_log_interaction with:
  channel: "slack", direction: "outbound", snippet: <first 100 chars of message>

**USE CASES:**
- Send approved outreach drafts to Slack contacts
- Follow up with a connection from the contacts-slack-scan skill

**EXAMPLES:**

Send a DM:
{ "slackUserId": "U012AB3CD", "text": "Hey Alice, following up on our last conversation..." }

Send to a specific workspace:
{ "slackUserId": "U012AB3CD", "text": "...", "workspaceId": "T012AB3CD" }

**RETURNS:**
{ ts, tsIso, channelId, workspaceId } — ts is the Slack message timestamp.
Returns an error if Slack is not connected or the user ID is invalid.`,
  inputSchema: {
    type: 'object' as const,
    properties: {
      slackUserId: {
        type: 'string',
        description: 'Slack user ID (U...) to send the message to',
      },
      text: {
        type: 'string',
        description: 'The message text to send',
      },
      workspaceId: {
        type: 'string',
        description: 'Slack team ID (T...) of the workspace. Omit to use any connected workspace.',
      },
    },
    required: ['slackUserId', 'text'],
  },
} as const;
